import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql, navigate } from 'gatsby';
import kebabCase from 'lodash/kebabCase';
import { Select } from '@comicrelief/component-library';
import Wrapper from './NewsFilter.styles';

export default (props) => {
  const data = useStaticQuery(graphql`
    {
      allContentfulPageArticle {
        edges {
          node {
            categories {
              title
            }
          }
        }
      }
     }
    `);

  return (
    <NewsFilter data={data} {...props} />
  );
};

const updateCategory = (value) => {
  if (value === 'All') {
    navigate('/news');
  } else {
    navigate(`/news/${kebabCase(value)}`);
  }
};

const getCategoryList = (categories, selectedCategory) => {
  const category = selectedCategory !== undefined ? selectedCategory : 'All';
  const list = [{ value: 'All', displayValue: 'All' }];
  categories.map((item) => {
    const selected = item === category;
    return list.push({ value: item, displayValue: item, selected });
  });

  return list;
};

const NewsFilter = ({ data, selectedCategory }) => {
  // Get posts with non empty categories Array
  // Return flat array of those categories' titles
  const categorieswithPosts = [];
  data.allContentfulPageArticle.edges
    .filter(post => post.node.categories && post.node.categories.length > 0)
    .map(post => categorieswithPosts.push(...post.node.categories.map(category => category.title)));
  // Remove duplicates from categories array by converting it to Set then back to array
  const categories = getCategoryList(
    Array.from(new Set(categorieswithPosts)), selectedCategory
  );

  return (
    <Wrapper>
      <Select
        label="FILTER BY CATEGORY:"
        options={categories}
        defaultValue={selectedCategory}
        description="Please select a category"
        // Needs to be a non-null value to keep the underlying component happy
        errorMsg=""
        onChange={(event) => { updateCategory(event.target.value); }}
        id="category-filter"
      />
    </Wrapper>
  );
};

NewsFilter.propTypes = {
  selectedCategory: PropTypes.string.isRequired,
  data: PropTypes.shape({
    allContentfulPageArticle: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            categories: PropTypes.arrayOf(
              PropTypes.shape({
                title: PropTypes.string
              })
            )
          })
        })
      )
    })
  }).isRequired
};
